import * as ConfirmationTermConstants from './confirmation-term.constants';

export default ConfirmationTermConstants;
